module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic.bfeb6094eaab271a1dbe.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-ExtraBoldItalic.ttf
// module id = ../../../../../src/assets/customfonts/OpenSans-ExtraBoldItalic.ttf
// module chunks = styles